import styled from 'styled-components'

import { LabelInfoIcon } from '@components/ui/svgIcons'
import { Tooltip } from '@components/ui/Tooltips'

const StyledLabelInfoIcon = styled(LabelInfoIcon)`
  color: inherit;
`

interface FieldLabelWithInfoTooltipProps {
  label: StringOrMessage
  tooltipText: StringOrMessage
}

/**
 * Temporary info labeled field label for MUI fields to be passed as label
 *
 * @param {FieldLabelWithInfoTooltipProps} { label, tooltipText }
 */
export function FieldLabelWithInfoTooltip({ label, tooltipText }: FieldLabelWithInfoTooltipProps) {
  return (
    <span>
      {label}
      <Tooltip title={tooltipText} placement="top">
        <StyledLabelInfoIcon />
      </Tooltip>
    </span>
  )
}
